import { render, staticRenderFns } from "./Speakabout.vue?vue&type=template&id=f447b24c&"
var script = {}
import style0 from "./Speakabout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports